"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormQuestionType = void 0;
var FormQuestionType;
(function (FormQuestionType) {
    FormQuestionType["TextInput"] = "textInput";
    FormQuestionType["MultiLineTextInput"] = "multiLineTextInput";
    FormQuestionType["MultipleSelection"] = "multipleSelection";
    FormQuestionType["DropDown"] = "dropDown";
    FormQuestionType["Checkbox"] = "checkbox";
    FormQuestionType["DateInput"] = "dateInput";
    FormQuestionType["TimeInput"] = "timeInput";
    FormQuestionType["RatingInput"] = "ratingInput";
    FormQuestionType["TextBlock"] = "textBlock";
    FormQuestionType["SignatureInput"] = "signatureInput";
    FormQuestionType["PetPicker"] = "petPicker";
})(FormQuestionType = exports.FormQuestionType || (exports.FormQuestionType = {}));
//# sourceMappingURL=FormQuestionType.js.map